import React, { Component } from "react";
import { Route, Switch } from "react-router";
import { Layout } from "./components/Layout";
import { Home } from "./components/Home";

import MainPage from "./MainPage";
import TodoList from "./components/TodoList/TodoList";
import JCMap from "./components/Map/JCMap";
//입고등록
import IpgoIndex from "./components/Ipgo/IpgoIndex";
import IpgoPrint from "./components/Ipgo/IpgoPrint";

//출고세금계산서 현황
import CholgoIndex from "./components/Cholgo/CholgoIndex";
import GesansuList from "./components/Gesansu/GesansuList";

//날씨정보
import Watch from "./components/WatchApi/Watch";
import WatchMenu from "./components/WatchApi/WatchMenu";
import WatchYebo from "./components/WatchApi/WatchYebo";
import WatchChart from "./components/WatchApi/WatchChart";

//수학천재비디오
import Math from "./VideoMath.js";
import VideoList from "./components/MoveVideo/VideoList";
// import VideoList from "./VideoList.js";

//직원사진등록
import EmpPopleList from "./components/Emp/EmpPopleList";
import EmpPopleListSerche from "./components/Emp/EmpPopleListSerche";
//디비오및이미지등록
import VideosList from "./components/Videos/VideosList";
import VideosListSerche from "./components/Videos/VideosListSerche";
//나의디비오및이미지등록
import VideosMyList from "./components/VideosMy/VideosMyList";
import VideosMyListSerche from "./components/VideosMy/VideosMyListSerche";
//양식저장및이미지등록
import YangList from "./components/Yangsic/YangList";
import YangsicListSerche from "./components/Yangsic/YangsicListSerche";

///구매업체등록
import PurchaseList from "./components/Purchases/Suppliers/PurchaseList";
import PurchaseListSerche from "./components/Purchases/Suppliers/PurchaseListSerche";
import MaterialList from "./components/Purchases/Materials/MaterialList";
import MaterialListSerche from "./components/Purchases/Materials/MaterialListSerche";
import MaterialInputList from "./components/Purchases/MaterialsInput/MaterialInputList";
import MaterialInputListSearch from "./components/Purchases/MaterialsInput/MaterialInputListSearch";

//생산성
import Productivity from "./components/Saengsanseong/Productivity.js";

export default class App extends Component {
	static displayName = App.name;
	render() {
		return (
			// 특정페이지 실행만실행-Switch
			<>
				<Switch>
					<Route path="/MainPage" component={MainPage} exact />
					<Route path="/TodoList/TodoList" component={TodoList} exact />
					<Route path="/Map/JCMap" component={JCMap} exact />

					<Route path="/Ipgo/IpgoIndex" component={IpgoIndex} exact />
					<Route path="/Ipgo/IpgoPrint" component={IpgoPrint} exact />

					<Route path="/Cholgo/CholgoIndex" component={CholgoIndex} exact /> {/* 출고세금계산서현황 */}
					<Route path="/Gesansu/GesansuList" component={GesansuList} exact /> {/* 실제출고세금계산서현황 정진또는 제이콥 */}


					<Route path="/WatchApi/Watch" component={Watch} exact /> {/* 초단기실황날씨정보 */}
					<Route path="/WatchApi/WatchYebo" component={WatchYebo} exact /> {/* 단가날씨예보 */}
					<Route path="/WatchApi/WatchChart" component={WatchChart} exact /> {/* 단가날씨예보 그래프 */}
					<Route path="/VideoList" component={VideoList} exact /> {/* 음악비디오 */}

					<Route path="/Emp/EmpPopleListSerche" component={EmpPopleListSerche} exact /> {/* 직원리스트 */}
					<Route path="/Emp/EmpPopleList" component={EmpPopleList} exact /> {/* 직원등록 */}

					<Route path="/Videos/VideosListSerche" component={VideosListSerche} exact /> {/* 비디오리스트 */}
					<Route path="/Videos/VideosList" component={VideosList} exact /> {/* 비디오등록 */}

					<Route path="/VideosMy/VideosMyListSerche" component={VideosMyListSerche} exact /> {/* 나의비디오리스트 */}
					<Route path="/VideosMy/VideosMyList" component={VideosMyList} exact /> {/* 나의비디오등록 */}

					<Route path="/yangsic/YangsicListSerche" component={YangsicListSerche} exact /> {/* 양신저장및등록리스트 */}
					<Route path="/Yangsic/YangList" component={YangList} exact /> {/* 양식저장및등록 */}

					<Route path="/Purchases/Suppliers/PurchaseList" component={PurchaseList} exact /> {/* 구매업체등록 */}
					<Route path="/Purchases/Suppliers/PurchaseListSerche" component={PurchaseListSerche} exact /> {/* 구매업체조회 */}
					<Route path="/Purchases/Materials/MaterialList" component={MaterialList} exact /> {/* 구매자재등록 */}
					<Route path="/Purchases/Materials/MaterialListSerche" component={MaterialListSerche} exact /> {/* 구매자재조회 */}
					<Route path="/Purchases/MaterialsInput/MaterialInputList" component={MaterialInputList} exact /> {/* 구매입출등록 */}

					<Route path="/Purchases/MaterialsInput/MaterialInputListSearch" component={MaterialInputListSearch} exact /> {/* 구매입출조회 */}
					<Route path="/Saengsanseong/Productivity" component={Productivity} exact /> {/* 생산성조회 */}
					
					<Layout>
						<Route exact path="/" component={Home} />
						<Route path="/Math" component={Math} exact /> {/* 수학천재비디오 */}
						<Route path="/WatchApi/Watch" component={WatchMenu} exact /> {/* 날씨예보 */}
					</Layout>
				</Switch>
			</>
		);
	}
}
